/**
 * Created by Vladislav on 20.03.2026.
 */

class WrapComponent extends BaseComponent {
    onAttach() {
        if (this.options.child) {
            this.node.setContentSize2(ComponentUtils.findChildByName(this.node, this.options.child).getContentSize());
            return;
        }

        cleverapps.UI.wrap(this.node);
    }
}

Prefab.registerComponent("WrapComponent", WrapComponent);
